import { render } from "./app-loader.vue?vue&type=template&id=7df75b80&scoped=true&ts=true"
import script from "./app-loader.vue?vue&type=script&lang=ts"
export * from "./app-loader.vue?vue&type=script&lang=ts"

import "./app-loader.vue?vue&type=style&index=0&id=7df75b80&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7df75b80"]])

export default __exports__